import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  useSEO("Admin Login", "");
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin"); else setError(res.error);
  };

  return (
    <section className="min-h-[80vh] flex items-center justify-center bg-[#0B192C] py-24 relative overflow-hidden" data-testid="admin-login">
      <div className="absolute inset-0 noise opacity-[0.05]" />
      <form onSubmit={submit} className="relative bg-white border-2 border-[#0B192C] hard-shadow-orange w-full max-w-md p-10">
        <div className="w-14 h-14 bg-[#FF5A00] flex items-center justify-center mb-6"><Lock className="text-white" /></div>
        <h1 className="font-head font-black uppercase text-4xl tracking-tighter">Admin Access</h1>
        <p className="text-[#475569] mt-2">Sign in to view quote requests and messages.</p>
        {error && <div className="mt-4 bg-red-50 border-2 border-red-500 text-red-700 px-4 py-3 text-sm" data-testid="admin-error">{error}</div>}
        <div className="mt-6 space-y-4">
          <div><Label className="font-head uppercase tracking-wide text-xs font-700">Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="mt-2 rounded-none border-2 border-[#0B192C]/15 h-12 focus-visible:ring-0 focus-visible:border-[#FF5A00]" /></div>
          <div><Label className="font-head uppercase tracking-wide text-xs font-700">Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="mt-2 rounded-none border-2 border-[#0B192C]/15 h-12 focus-visible:ring-0 focus-visible:border-[#FF5A00]" /></div>
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-button" className="mt-6 w-full bg-[#0B192C] text-white font-head font-700 uppercase tracking-[0.2em] py-4 flex items-center justify-center gap-2 hover:bg-[#FF5A00] transition-colors disabled:opacity-60">{loading ? "Signing in..." : <>Sign In <ArrowRight size={18} /></>}</button>
      </form>
    </section>
  );
}
